import {rootState} from '@mintdata-wsp/common/state/RootState';
import {ICommandMenuItem} from '@mintdata-wsp/common/state/ui/visualDesigner/CommandMenuState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {ErrorPopupSide, InputStyle} from '@mintdata-wsp/wsp/ui/components/forms/Input';
import {InputField} from '@mintdata-wsp/wsp/ui/components/forms/InputField';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {Scrollable, ScrollBehavior} from '@mintdata-wsp/wsp/ui/components/scrollable/Scrollable';
import {BaseComponentWithContext} from '@mintdata/mint-kit/api/components/BaseComponentWithContext';
import {GUID} from '@mintdata/mint-kit/api/models/GUID';
import {Popover} from '@mintdata/mint-kit/impl/components/popover/Popover';
import {PopupAnchor, SourceAnchor} from '@mintdata/mint-kit/impl/components/popover/PopupTypes';
import {IdUtil} from '@mintdata/mint-kit/impl/util/IDUtil';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {action} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';
import {HotKeys} from 'react-hotkeys';

const styles = require('./CommandMenu.less');
const cx = classnames.bind(styles);

@observer
export class CommandMenu extends BaseComponentWithContext<any>
{
    private _popupId:GUID = IdUtil.newGUID();

    @bind
    private _renderFilterUI()
    {
        return <Row className={cx('filterRow')}>
            <InputField
                style={InputStyle.Simple}
                className={cx('inputField')}
                labelClassName={cx('inputFieldLabel')}
                label={null}
                icon={null}
                placeholder={'Enter command...'}
                errorPopupSide={ErrorPopupSide.Bottom}
                initialValue={''}
                isInitiallyFocused={true}
                isValidFn={(value:string) =>
                {
                    return true;
                    // return value && value.length > 0;
                }}
                onChange={action((newValue:any) =>
                {
                    const {ui: {commandMenu}} = controllers;

                    commandMenu.filterItems(!newValue || newValue.length === 0 ? null : newValue);

                    return true;
                })}
            />
        </Row>;
    }

    @bind
    private _renderItems()
    {
        const {ui: {visualDesigner: {commandMenuState: {filteredItems, selectedItemIndex}}}} = rootState;
        const {ui: {commandMenu}} = controllers;

        return filteredItems.map((item:ICommandMenuItem, index:number) =>
        {
            return <div
                key={index}
                id={`commandItem_${index}`}
                className={cx('item', {'selected': index === selectedItemIndex})}
                onClick={() => commandMenu.onItemClick(item, index)}
            >
                <span className={cx('itemType', item.type)}>
                    {item.type}
                </span>
                <span className={styles.itemText}>{item.text}</span>
                {item.data.cellRefText && <span className={styles.itemText}>!{item.data.cellRefText}</span>}
            </div>;
        });
    };

    render()
    {
        const {popupManager} = this.context;
        const {ui: {visualDesigner: {commandMenuState: {isMenuOpen, selectedItemIndex}}}} = rootState;
        const {commandMenu} = controllers.ui;

        const keyMap = commandMenu.getKeyMap();
        const keyHandlers = commandMenu.getKeyHandlers();

        return isMenuOpen && <div
            className={styles.base}
            ref={popupManager.position(this._popupId, SourceAnchor.CenterTop, PopupAnchor.CenterTop)}
        >
            <Popover id={this._popupId} onDismissed={commandMenu.onDismissed}>
                <HotKeys
                    keyMap={keyMap}
                    handlers={keyHandlers}
                    attach={document.body}
                    className={styles.content}
                >
                    <Column className={cx('commandMenu')}>
                        {this._renderFilterUI()}

                        <Scrollable isScrollX={false}
                                    isScrollY={true}
                                    behavior={ScrollBehavior.OnSelect}
                                    selectedItemId={`commandItem_${selectedItemIndex}`}
                        >
                            <Column className={cx('itemsSection')}>
                                {this._renderItems()}
                            </Column>
                        </Scrollable>

                    </Column>
                </HotKeys>
            </Popover>
        </div>;
    }
}
